import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

export interface FooterCard {
  h: ReactNode
  p: ReactNode
  ink?: boolean
}

export function FooterStrip({
  cards,
  className,
  style
}: {
  cards: FooterCard[]
  className?: string
  style?: CSSProperties
}) {
  return (
    <div className={className ? `st-foot-strip ${className}` : 'st-foot-strip'} style={style}>
      {cards.map((c, i) => (
        <div key={i} className={cx('st-foot-card', c.ink && 'ink')}>
          <h4>{c.h}</h4>
          <p>{c.p}</p>
        </div>
      ))}
    </div>
  )
}
